// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sb__TlZBl {
  background-color: var(--color-admin);
  color: var(--color-white);
  box-sizing: border-box;
  padding: 4rem 2rem;
  min-height: 100vh;
  cursor: pointer;
  width: 30vw;
  transition: all 850ms;
}
@media only screen and (max-width: 50em) {
  .Sidebar_sb__TlZBl {
    width: 40vw;
  }
}
@media only screen and (max-width: 37.5em) {
  .Sidebar_sb__TlZBl {
    width: 70vw;
  }
}
.Sidebar_sb_title__3jop2 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 2rem;
}
.Sidebar_sb_title__3jop2 > :not(:last-child) {
  margin-right: 3rem;
}
.Sidebar_sb_icon__c4X3N {
  font-size: 3rem;
}
.Sidebar_sb_logo__FgM4x {
  height: 3rem;
}
.Sidebar_sb_nav__0CzGT {
  box-sizing: border-box;
  padding: 3rem 1rem;
  height: 87vh;
  overflow-y: auto;
}
.Sidebar_sb_nav__0CzGT::-webkit-scrollbar {
  width: 0.5rem;
  background-color: var(--color-white);
}
.Sidebar_sb_nav__0CzGT::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
}
.Sidebar_sb_nav_ul__SIy2E {
  display: flex;
  flex-direction: column;
  align-items: space-evenly;
  margin: 0;
  padding: 0;
  gap: 1rem;
  list-style: none;
}
.Sidebar_sb_nav_ul__SIy2E > * {
  padding: 0.75rem 2rem;
  list-style: none;
}
.Sidebar_sb_nav_item__OJG2Q {
  font-size: var(--default-font-small);
  font-weight: 700;
}
.Sidebar_sb_nav_item_active__KMYr\\+, .Sidebar_sb_nav_item__OJG2Q:hover {
  background-color: var(--color-white);
  color: var(--color-dark);
  border-radius: 0.75rem;
}
.Sidebar_sb_nav_link__jm0mm {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.Sidebar_sb_nav_link_icon__j1GwF {
  font-size: 2rem;
}
.Sidebar_sb_nav_link_arr__diHFd {
  font-size: 2rem;
  transform: rotateX(180deg);
}
.Sidebar_sb_nav_link_arr_1__gCcDj {
  font-size: 2rem;
}
.Sidebar_sb_nav_link_group__XgctE {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Sidebar_subNav_ul__rerUN {
  display: flex;
  flex-direction: column;
  align-items: space-evenly;
  margin: 1rem 0;
  padding: 0;
  gap: 0.5rem;
  list-style: none;
}
.Sidebar_subNav_ul__rerUN > * {
  padding: 0.75rem 3rem;
  list-style: none;
}
.Sidebar_subNav_li_active__DMzIy, .Sidebar_subNav_li__sLroE:hover {
  background-color: var(--color-admin);
  color: var(--color-white);
  border-radius: 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/AppHome/Sidebar.module.scss"],"names":[],"mappings":"AAEA;EACC,oCAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AADD;AAGC;EAVD;IAWE,WAAA;EAAA;AACF;AAEC;EAdD;IAeE,WAAA;EACA;AACF;AACC;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACC,kBAAA;AACH;AAGC;EACC,eAAA;AADF;AAIC;EACC,YAAA;AAFF;AAKC;EACC,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AAHF;AAKE;EACC,aAAA;EACA,oCAAA;AAHH;AAME;EACC,mCAAA;AAJH;AAOE;EACC,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AALH;AAOG;EACC,qBAAA;EACA,gBAAA;AALJ;AASE;EACC,oCAAA;EACA,gBAAA;AAPH;AASG;EAEC,oCAAA;EACA,wBAAA;EACA,sBAAA;AARJ;AAYE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAVH;AAYG;EACC,eAAA;AAVJ;AAaG;EACC,eAAA;EACA,0BAAA;AAXJ;AAaI;EACC,eAAA;AAXL;AAeG;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAbJ;;AAqBC;EACC,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AAlBF;AAqBE;EACC,qBAAA;EACA,gBAAA;AAnBH;AA0BE;EAEC,oCAAA;EACA,yBAAA;EACA,sBAAA;AAzBH","sourcesContent":["@import '../variables/breakpoints';\n\n.sb {\n\tbackground-color: var(--color-admin);\n\tcolor: var(--color-white);\n\tbox-sizing: border-box;\n\tpadding: 4rem 2rem;\n\tmin-height: 100vh;\n\tcursor: pointer;\n\twidth: 30vw;\n\ttransition: all 850ms;\n\n\t@media only screen and (max-width: $bp-medium) {\n\t\twidth: 40vw;\n\t}\n\n\t@media only screen and (max-width: $bp-small) {\n\t\twidth: 70vw;\n\t}\n\n\t&_title {\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tpadding-left: 2rem;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\t}\n\n\t&_icon {\n\t\tfont-size: 3rem;\n\t}\n\n\t&_logo {\n\t\theight: 3rem;\n\t}\n\n\t&_nav {\n\t\tbox-sizing: border-box;\n\t\tpadding: 3rem 1rem;\n\t\theight: 87vh;\n\t\toverflow-y: auto;\n\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: .5rem;\n\t\t\tbackground-color: var(--color-white);\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground-color: var(--color-grey);\n\t\t}\n\n\t\t&_ul {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: space-evenly;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tgap: 1rem;\n\t\t\tlist-style: none;\n\n\t\t\t&>* {\n\t\t\t\tpadding: 0.75rem 2rem;\n\t\t\t\tlist-style: none;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tfont-size: var(--default-font-small);\n\t\t\tfont-weight: 700;\n\n\t\t\t&_active,\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-white);\n\t\t\t\tcolor: var(--color-dark);\n\t\t\t\tborder-radius: 0.75rem;\n\t\t\t}\n\t\t}\n\n\t\t&_link {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 1rem;\n\n\t\t\t&_icon {\n\t\t\t\tfont-size: 2rem;\n\t\t\t}\n\n\t\t\t&_arr {\n\t\t\t\tfont-size: 2rem;\n\t\t\t\ttransform: rotateX(180deg);\n\n\t\t\t\t&_1 {\n\t\t\t\t\tfont-size: 2rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&_group {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.subNav {\n\n\t&_ul {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: space-evenly;\n\t\tmargin: 1rem 0;\n\t\tpadding: 0;\n\t\tgap: .5rem;\n\t\tlist-style: none;\n\n\n\t\t&>* {\n\t\t\tpadding: 0.75rem 3rem;\n\t\t\tlist-style: none;\n\t\t}\n\n\t}\n\n\t&_li {\n\n\t\t&_active,\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-admin);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0.75rem;\n\t\t}\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sb": `Sidebar_sb__TlZBl`,
	"sb_title": `Sidebar_sb_title__3jop2`,
	"sb_icon": `Sidebar_sb_icon__c4X3N`,
	"sb_logo": `Sidebar_sb_logo__FgM4x`,
	"sb_nav": `Sidebar_sb_nav__0CzGT`,
	"sb_nav_ul": `Sidebar_sb_nav_ul__SIy2E`,
	"sb_nav_item": `Sidebar_sb_nav_item__OJG2Q`,
	"sb_nav_item_active": `Sidebar_sb_nav_item_active__KMYr+`,
	"sb_nav_link": `Sidebar_sb_nav_link__jm0mm`,
	"sb_nav_link_icon": `Sidebar_sb_nav_link_icon__j1GwF`,
	"sb_nav_link_arr": `Sidebar_sb_nav_link_arr__diHFd`,
	"sb_nav_link_arr_1": `Sidebar_sb_nav_link_arr_1__gCcDj`,
	"sb_nav_link_group": `Sidebar_sb_nav_link_group__XgctE`,
	"subNav_ul": `Sidebar_subNav_ul__rerUN`,
	"subNav_li_active": `Sidebar_subNav_li_active__DMzIy`,
	"subNav_li": `Sidebar_subNav_li__sLroE`
};
export default ___CSS_LOADER_EXPORT___;
